import { EEthereumNetworkId } from '@ankr.com/provider';

enum Env {
  DEV = 'dev',
  STAGE = 'stage',
  PROD = 'prod',
}

interface ContractAddresses {
  cronTaskFactory: string;
  registry: string;
  registrar: string;
}

interface UrlAddresses {
  api: string;
  rpc: string;
  explorer: string;
}

export interface NetworkConfig {
  contracts: ContractAddresses;
  urls: UrlAddresses;
}

type EnvConfig = {
  [key in EEthereumNetworkId]?: NetworkConfig;
};

const PROD_CONFIG: EnvConfig = {
  [EEthereumNetworkId.smartchain]: {
    contracts: {
      cronTaskFactory: '0xbB2b96000b241936486F918D99462402c4dE3ABE',
      registry: '0x5f0c42637513Cb84F5DA7938677fc7d427BEa99F',
      registrar: '0xf20164c84bac9A8012636F81c5BA1F2B7876Faf2',
    },
    urls: {
      api: 'https://keeper.prod.automate.ankr.com/v1/bsc',
      rpc: 'https://rpc.ankr.com',
      explorer: 'https://bscscan.com',
    },
  },
  [EEthereumNetworkId.smartchainTestnet]: {
    contracts: {
      cronTaskFactory: '0x2dDcf7438D5e57152e1e343E4e0ee7DAF0166614',
      registry: '0xD6929f0F366f7A2363833aDAAfFe29E38853a16F',
      registrar: '0x8Dcd23ce522D0d7eA7d15e3134e0509f8f6eEfD8',
    },
    urls: {
      api: 'https://keeper.dev.staking.ankr.com/v1/bsc',
      rpc: 'https://rpc.ankr.com',
      explorer: 'https://testnet.bscscan.com',
    },
  },
  [EEthereumNetworkId.mumbai]: {
    contracts: {
      cronTaskFactory: '0x342cBaD4c51aA8eFB6393BA824f8C6bF6Df79D7F',
      registry: '0xda8370dDE1fA79c82E8BB28F7BB4c3F72Cb5E11c',
      registrar: '0x9892C5656d9193e293645bBd202D0FBc7e9df33A',
    },
    urls: {
      api: 'https://keeper.dev.staking.ankr.com/v1/polygon',
      rpc: 'https://rpc.ankr.com',
      explorer: 'https://mumbai.polygonscan.com',
    },
  },
  [EEthereumNetworkId.polygon]: {
    contracts: {
      cronTaskFactory: '0x5f0c42637513Cb84F5DA7938677fc7d427BEa99F',
      registry: '0xf20164c84bac9A8012636F81c5BA1F2B7876Faf2',
      registrar: '0x6Fa8c49d61d77851D3b7269fe72069C61D57CFF8',
    },
    urls: {
      api: 'https://keeper.prod.automate.ankr.com/v1/polygon',
      rpc: 'https://rpc.ankr.com',
      explorer: 'https://polygonscan.com',
    },
  },
};

const config: Record<Env, EnvConfig> = {
  [Env.DEV]: PROD_CONFIG,
  [Env.STAGE]: PROD_CONFIG,
  [Env.PROD]: PROD_CONFIG,
};

export default config[process.env.REACT_APP_ENV as Env];
